import React, { useEffect } from 'react';

// Contexts

import Landinger from 'components/Landinger/LandingerV2';

function App() {
	useEffect(() => {
		console.log(
			'%cPress: "alt" + "shift" + "r" to reset cookie banner',
			'color:green;font-weight:bold;border:1px solid black;padding: 1rem;'
		);
	}, []);

	return (
		<>
			<Landinger />
		</>
	);
}

export default App;
